import { Input, InputGroup, InputRightElement } from "@chakra-ui/react";
import React from "react";
import { ReactComponent as Eye } from "../../svg/eye.svg";
import { ReactComponent as EyeSlash } from "../../svg/eyeSlash.svg";


export default function PasswordInput({register, name, ...rest}) {
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);

  return (
    <InputGroup>
      <Input type={show ? "text" : "password"} {...rest} {...register(name)}/>
      <InputRightElement
        width="4.5rem"
        children={!show ? <EyeSlash /> : <Eye />}
        onClick={handleClick}
      />
    </InputGroup>
  );
}
